import { createSlice } from '@reduxjs/toolkit';
import { HttpRequestType } from "../../adapters/xhr/RequestStatus";
import { RequestStatus } from "../../adapters/xhr/RequestStatus";
import { ApiURLs, API_BASE_URL } from '../../common/url';
import { AppLocalStorage, AppLocalStorageItems } from '../../helpers/localStorageHelper';
import { AsyncThunkAction } from '../asyncThunk';

const initialState = {
  userInfo: {
    isAuthenticated: false,
    userName: '', 
    email: '', 
    role: '', 
    permissions : [],
    expiryDateTimeUnixMilliseconds : 0,
    status: RequestStatus.Idle,
    loginKeyReset: true
  },
  token: AppLocalStorage.getStorageItem(AppLocalStorageItems.Key),
  tokenExpired: true,
  // captcha: null,
}

export const verifyUserCredentials = AsyncThunkAction('auth/verifyKey', API_BASE_URL + ApiURLs.Auth.VerifyToken)
export const basicFormAuthentication = AsyncThunkAction('auth/form', API_BASE_URL + ApiURLs.Auth.BasicFormAuthentication)
export const resetFormAuthentication = AsyncThunkAction('auth/form/reset', API_BASE_URL + ApiURLs.Auth.FormAuthPasswordReset, HttpRequestType.PATCH)
export const logoutUser = AsyncThunkAction('auth/user/logout', API_BASE_URL + ApiURLs.Auth.LogoutUser,HttpRequestType.POST)
export const authTokenKey = AsyncThunkAction('auth/form/authTokenKey', API_BASE_URL + ApiURLs.Auth.AuthTokenKey,HttpRequestType.GET)
export const fetchCaptcha = AsyncThunkAction('auth/generateCaptcha', API_BASE_URL + ApiURLs.Auth.GenerateCaptcha, HttpRequestType.GET);


const token_key_local = AppLocalStorageItems.Key
const authSlice = createSlice({
  name: 'auth',
  initialState: initialState,
  reducers: {
    setUserAuth: (state, action) => {
      const payload = action?.payload || {};
      const userInfo = {
        isAuthenticated: payload.userName ? true : false,
        token: payload.token,
        profilePic: payload.profilePic,
        userName: payload.userName,
        status: RequestStatus.Fulfilled,
        email: payload.email,
        role: payload.role,
        permissions: payload.permissions,
        loginKeyReset: payload.loginKeyReset,
        expiryDateTimeUnixMilliseconds: payload.expiryDateTimeUnixMilliseconds
      }
      AppLocalStorage.setStorageItem(token_key_local, userInfo.token)
      AppLocalStorage.setStorageItem(AppLocalStorageItems.ProfilePic, userInfo.profilePic)

      state.token =  userInfo.token
      state.userInfo = userInfo   
      if(state.token)
      sessionStorage.setItem("logged", true);
    },
    setKeyReset: (state, action) => {
      state.userInfo.loginKeyReset = action.payload
    },
    setRefreshToken: (state, action) => {
      state.token = action.payload.token
      AppLocalStorage.setStorageItem(AppLocalStorageItems.RefreshTokenTimeStamp, action.payload.timestamp)
      AppLocalStorage.setStorageItem(token_key_local, action.payload.token)
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(verifyUserCredentials.pending, (state, action) => {
        state.userInfo.status = RequestStatus.Pending;
      })
      .addCase(verifyUserCredentials.fulfilled, (state, action) => {
          state.userInfo.isAuthenticated = action.payload.data.isValidIdentity
          state.userInfo.userName = action.payload.data.userName
          state.userInfo.email = action.payload.data.email
          state.userInfo.role = action.payload.data.role
          state.userInfo.permissions = action.payload.data.permissions
          state.userInfo.expiryDateTimeUnixMilliseconds = action.payload.data.expiryDateTimeUnixMilliseconds
          state.userInfo.loginKeyReset = action.payload.data.loginKeyReset
          state.userInfo.status = RequestStatus.Fulfilled          
          state.tokenExpired = action.payload.data.isExpired

          if(action.payload.status === 401){
            AppLocalStorage.removeStorageItem(token_key_local)
          }
          else if(action.payload.status === 403){
            state.userInfo.noPermission = true;
          }
      }).addCase(verifyUserCredentials.rejected, (state, action) => {
        state.userInfo.status = RequestStatus.Rejected
        state.userInfo.isAuthenticated = false
      })
  }
})

export const { setUserAuth, setKeyReset,setRefreshToken } = authSlice.actions;
export default authSlice.reducer